var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { cn } from 'root/src/client/v2/common/helpers/cn';
// Lightweight toggle (role="switch"); keeps a plain boolean API like the redesign Checkbox and
// avoids pulling in a new Radix dependency for such a small control.
export const Switch = (_a) => {
    var { checked, onCheckedChange, id, disabled, className } = _a, props = __rest(_a, ["checked", "onCheckedChange", "id", "disabled", "className"]);
    return (<button id={id} type="button" role="switch" aria-checked={checked} disabled={disabled} onClick={() => onCheckedChange(!checked)} className={cn('relative inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border border-solid border-transparent transition-colors', 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 disabled:cursor-not-allowed disabled:opacity-50', checked ? 'bg-primary' : 'bg-white/[0.12]', className)} {...props}>
		<span className={cn('pointer-events-none block h-5 w-5 rounded-full bg-white shadow transition-transform', checked ? 'translate-x-[22px]' : 'translate-x-0.5')}/>
	</button>);
};
